<script setup>
/**
 * LLM 后台的路由外壳 —— **这一层就是 admin 守卫**。
 *
 * `AdminShell` 的 `forbidden` 是整体性的(role 不在 `admin|operator` 里就换掉整个 RouterView),
 * 它挡不住 operator 打开 LLM 页面 —— 而 LLM 后台比候补名单更严,只对 `admin` 开放。
 * 守在这里(而不是各页面里)的好处:后面六片各自往 children 里加路由,自动都被守住。
 *
 * **前端隐藏只是体验,后端才是权限**:每个 handler 都有 `requireEditorRole(request, services, ['admin'])`。
 * 这张卡片是为了不让人点进去看到一屏 403。
 */
import { computed } from 'vue'
import { ShieldAlert } from '@lucide/vue'
import { Card } from '@drama/ui'
import { useI18n } from 'vue-i18n'
import { useAdminAuth } from '../../composables/useAdminAuth.js'

const { t } = useI18n()
const auth = useAdminAuth()

const isAdmin = computed(() => auth.account.value?.role === 'admin')
</script>

<template>
  <Card
    v-if="!isAdmin"
    data-insp-path="apps/visual-game-admin/src/pages/llm/LlmSection.vue#forbidden"
  >
    <div class="llm-forbidden">
      <ShieldAlert :size="32" />
      <h1>{{ t('visualGameAdmin.llm.forbidden.title') }}</h1>
      <p>{{ t('visualGameAdmin.llm.forbidden.description') }}</p>
    </div>
  </Card>
  <RouterView v-else />
</template>

<style scoped>
.llm-forbidden {
  display: grid;
  justify-items: center;
  gap: var(--drama-space-md);
  padding: var(--drama-space-2xl);
  text-align: center;
  color: var(--drama-color-text-muted);
}

.llm-forbidden h1 {
  margin: 0;
  color: var(--drama-color-text);
  font-size: var(--drama-font-size-lg);
}

.llm-forbidden p {
  margin: 0;
  max-width: 520px;
}
</style>
